import type { ReactNode } from 'react';
import './controls.css';

interface ControlSectionProps {
  title: string;
  children: ReactNode;
  cols?: 2 | 3;
}

// ControlSection — wrappt section-header + tile-grid. Een ControlsColumn-sectie.
// Geen state, geen side-effects. Cols default 2 — matched mockup-keuze.
export function ControlSection({ title, children, cols = 2 }: ControlSectionProps) {
  return (
    <div className="ctl-section">
      <div className="ctl-section-header">{title}</div>
      <div className={`ctl-section-grid ctl-section-grid--cols-${cols}`}>
        {children}
      </div>
    </div>
  );
}
